import React from 'react';

const content = (props) => (
    <div className='content-wrapper' style={{minHeight: window.innerHeight-101 + 'px'}}>
        {props.children}
    </div>
);

export default content;
